<div *ngIf="showNotification" [@toggleNotification] class="interview-notification">
  <div class="interview-notification-open" (click)="onOpen()">
    <div class="interview-notification-img">
      <img src="assets/images/interview-notification-img.png" alt="Interview Img" />
    </div>
    <div class="interview-notification-text">
      <p>{{ 'interviewWidget.notification.title' | translate }}</p>
      <a href="javascript:;">{{ 'interviewWidget.notification.description' | translate }}</a>
    </div>
  </div>
  <div class="interview-notification-close">
    <a (click)="onClose()"><span class="icon-i-close"></span></a>
  </div>
</div>
